import { render, staticRenderFns } from "./dashboard_nuevo.vue?vue&type=template&id=272ae074&scoped=true"
import script from "./dashboard_nuevo.vue?vue&type=script&lang=js"
export * from "./dashboard_nuevo.vue?vue&type=script&lang=js"
import style0 from "./dashboard_nuevo.vue?vue&type=style&index=0&id=272ae074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ae074",
  null
  
)

export default component.exports